import { Route, Routes } from 'react-router-dom';
import Index from './pages/Index';
import SizingPageWithPersonas from './pages/SizingPageWithPersonas';
import CostSimulator from './pages/CostSimulator';
import SizingCostCombined from './pages/SizingCostCombined';
import Downloads from './pages/Downloads';
import Models from './pages/Models';
import Containers from './pages/Containers';
import Collateral from './pages/Collateral';
import Installer from './pages/Installer';
import NotFound from './pages/NotFound';
import WizardPage from './pages/WizardPage';
import Dashboard from './pages/Dashboard';
import AdminPersonas from './pages/AdminPersonas';
import Blueprints from './pages/Blueprints';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<SizingCostCombined />} />
    <Route path="/home" element={<Index />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/sizing" element={<SizingPageWithPersonas />} />
    <Route path="/wizard" element={<WizardPage />} />
    <Route path="/admin/personas" element={<AdminPersonas />} />
    <Route path="/cost-simulator" element={<CostSimulator />} />
    <Route path="/sizing-tco" element={<SizingCostCombined />} />
    <Route path="/downloads" element={<Downloads />} />
    <Route path="/blueprints" element={<Blueprints />} />
    <Route path="/models" element={<Models />} />
    <Route path="/containers" element={<Containers />} />
    <Route path="/collateral" element={<Collateral />} />
    <Route path="/installer" element={<Installer />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
